'use strict';

module.exports = function legalAge (today, birthday ) {
  // do NOT use UTCYear et al - a bar ID check would use local dates
  let age = today.getFullYear() - birthday.getFullYear();

  if (today.getMonth() < birthday.getMonth()
      && today.getDate() < birthday.getDate()) {
    age = age - 1;
  }

  return age;
};



// WEBPACK FOOTER //
// ./lib/rlink-agegate/legalAge.js